import React from "react";

interface AlfaSegurosLogoProps extends React.SVGProps<SVGSVGElement> {
	width?: string | number;
	height?: string | number;
}

// O viewBox foi ajustado para acomodar bem o logo e a linha de base.
export const AlfaSegurosLogo: React.FC<AlfaSegurosLogoProps> = ({ width = "180", height = "50", ...props }) => {
	// Cores extraídas da imagem:
	const mainBlue = "#16284C"; // Azul marinho
	const mainGold = "#FFCC00"; // Dourado do topo
	const accentLine = "#4E6A8C"; // Cor mais clara para as linhas da pirâmide

	// --- AJUSTE DE POSIÇÃO FEITO AQUI ---
	// Posição inicial do texto "ALFA" é x="0".
	// Reduzimos o valor de pyramidX (era 90) para aproximar da "ALFA".
	const pyramidWidth = 30;
	const pyramidHeight = 30;
	const pyramidX = 68; // Ajustado de 90 para 68
	const pyramidY = 5;
	const pyramidBase = pyramidX + pyramidWidth / 2;
	// --- FIM DO AJUSTE DE POSIÇÃO ---

	// Função para desenhar as linhas da grade
	const renderPyramidGrid = () => {
		const lines = [];
		const base = pyramidY + pyramidHeight;

		// Linhas Horizontais
		for (let i = 1; i <= 3; i++) {
			const y = base - i * (pyramidHeight / 4);
			// Calcula o ponto de intersecção com o triângulo
			const xOffset = i * (pyramidWidth / 8);
			lines.push(
				<line key={`h-${i}`} x1={pyramidX + xOffset} y1={y} x2={pyramidX + pyramidWidth - xOffset} y2={y} stroke={accentLine} strokeWidth="0.5" />
			);
		}

		// Linhas Diagonais (Esquerda)
		for (let i = 1; i <= 3; i++) {
			const x = pyramidX + i * (pyramidWidth / 4);
			const y = base - i * (pyramidHeight / 4);
			lines.push(<line key={`dl-${i}`} x1={x} y1={base} x2={pyramidBase} y2={pyramidY} stroke={accentLine} strokeWidth="0.5" />);
		}

		// Linhas Diagonais (Direita)
		for (let i = 1; i <= 3; i++) {
			const x = pyramidX + pyramidWidth - i * (pyramidWidth / 4);
			lines.push(<line key={`dr-${i}`} x1={x} y1={base} x2={pyramidBase} y2={pyramidY} stroke={accentLine} strokeWidth="0.5" />);
		}

		return lines;
	};

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 220 50" // Largura do viewBox aumentada para 220
			width={width}
			height={height}
			{...props}
		>
			<style type="text/css">
				{`
                .alfa-text-style { 
                    fill: ${mainBlue}; 
                    font-family: serif; /* Simula a fonte com serifa do logo */ 
                    font-weight: bold; 
                }
                .alfa-base-line { 
                    stroke: ${mainBlue}; 
                    stroke-width: 1.5; 
                }
                .alfa-pyramid-outline {
                    fill: none;
                    stroke: ${mainBlue};
                    stroke-width: 1;
                }
                `}
			</style>

			<g id="Alfa_Seguros_Logo_Simulacao_Melhorada">
				{/* Texto "ALFA" */}
				<text x="0" y="34" fontSize="25" className="alfa-text-style">
					ALFA
				</text>

				{/* --- ÍCONE DA PIRÂMIDE --- */}
				{/* O grupo da pirâmide está posicionado via pyramidX = 68 */}
				<g>
					{/* Contorno Principal da Pirâmide */}
					<polygon
						points={`${pyramidBase},${pyramidY} ${pyramidX},${pyramidY + pyramidHeight} ${pyramidX + pyramidWidth},${pyramidY + pyramidHeight}`}
						className="alfa-pyramid-outline"
					/>

					{/* Linhas de Grade Interna */}
					{renderPyramidGrid()}

					{/* Triângulo Dourado do topo */}
					<polygon points={`${pyramidBase},${pyramidY} ${pyramidBase - 5},${pyramidY + 10} ${pyramidBase + 5},${pyramidY + 10}`} fill={mainGold} />
				</g>

				{/* Texto "SEGUROS" */}
				{/* Posição x ajustada para ficar mais próxima da pirâmide */}
				<text x="100" y="34" fontSize="25" className="alfa-text-style">
					SEGUROS
				</text>

				{/* Linha Fina Abaixo do Logo */}
				{/* x2 ajustado para 220, correspondendo ao novo viewBox */}
				<line x1="0" y1="45" x2="220" y2="45" className="alfa-base-line" />
			</g>
		</svg>
	);
};
